module.exports = __webpack_public_path__ + "static/media/sygnet.a7aac6a6.svg";